/* disclaimer-link:
 *
 * Add a "disclaimer declaration" button which
 * will toggle a pop-up info box.
 *
 * Author: Tim Bauwens
 * Copyright 2019 Berkeley Bridge
 *
 */
import { escapeHTML } from "$json/lib/escape";
import { converter } from "$md-converter";

(function ($, win, doc) {
  const disclaimers = {
    a: `We hebben ons best gedaan om de teksten van deze Regelhulp zo begrijpelijk mogelijk op te schrijven.
    De teksten van deze Regelhulp geven u geen rechten.`,
    b: `Let op: deze tool is mede door het Servicecentrum Regelhulpen van RVO ontwikkeld als hulpmiddel.
    U kunt geen rechten ontlenen aan de teksten en de uitkomsten van deze Regelhulp.
    RVO en/of de eigenaar van de tool zijn niet verantwoordelijk voor de inhoud van externe
    websites waarnaar de uitkomsten verwijzen. Ook bieden de uitkomsten geen garantie voor bijvoorbeeld een indiening.
    De antwoorden die u geeft en de gegevens die u via de tool krijgt, zijn voor uw eigen gebruik.
    RVO en/of de eigenaar van de Regelhulp registreren alleen hoe vaak een tool wordt gebruikt.`
  };

  var models = {
    efactureren: {
      mdable: false,
      text: disclaimers.a
    },
    einvoice: {
      mdable: false,
      text: `We have tried to make the texts of this Guide as comprehensive as possible. These texts do not grant you any rights.`
    },
    internationaalmkb: {
      mdable: false,
      text: `We hebben ons best gedaan om de inhoud en
        de teksten van deze Regelhulp zo volledig en begrijpelijk mogelijk op te schrijven.
        U kunt geen rechten ontlenen aan de teksten en adviezen van de Exportwijzer.`
    },
    xpw20: {
      mdable: false,
      text: `We hebben ons best gedaan om de inhoud en
        de teksten van deze Regelhulp zo volledig en begrijpelijk mogelijk op te schrijven.
        U kunt geen rechten ontlenen aan de teksten en adviezen van de Exportwijzer.`
    },
    rie: {
      mdable: false,
      text: `We hebben ons best gedaan om de inhoud en
        de teksten van deze Regelhulp zo volledig en begrijpelijk mogelijk op te schrijven.
        U kunt geen rechten ontlenen aan de teksten en adviezen van Regelhulp RI&E.`
    },
    betrouwbaarheidsniveau_digitale_dienstverlening: {
      mdable: false,
      text: `Begin juli 2020 is de conceptregeling betrouwbaarheidsniveaus WDO in consultatie gegaan.
        De teksten van deze regelhulp zijn hier nog niet op gebaseerd.
        De teksten van deze Regelhulp geven u geen rechten.`
    },
    kringloopscan: {
      mdable: false,
      text: disclaimers.a
    },
    e_besparing: {
      mdable: false,
      text: `We hebben ons best gedaan om de teksten van de Wetchecker Energiebesparing zo
        begrijpelijk mogelijk op te schrijven. Aan de teksten en resultaten uit deze Regelhulp kunt u geen rechten ontlenen.`
    },
    regelhulpchina: {
      mdable: false,
      text: disclaimers.a
    },
    ics: {
      mdable: false,
      text: disclaimers.a
    },
    risicoklasseindeling_digitaleveiligheid: {
      mdable: false,
      text: disclaimers.a
    },
    regelhulpinternationalefinanciering: {
      mdable: false,
      text: disclaimers.b
    },
    regelhulpmest: {
      mdable: false,
      text: disclaimers.b
    },
    vastgoed_transformatie: {
      mdable: false,
      text: disclaimers.b
    },
    wbso: {
      mdable: false,
      text: disclaimers.b
    },
    IE_calculator: {
      mdable: false,
      text: disclaimers.b
    },
    ie_calculator: {
      mdable: false,
      text: disclaimers.b
    },
    regelhulpbetrouwbaarheidniveaus: {
      mdable: true,
      text: `

  - Deze regelhulp helpt u het best passende betrouwbaarheidsniveau te kiezen voor de toegang tot uw digitale dienst(en). U bent zelf verantwoordelijk voor de beoordeling van de risico’s en de uiteindelijke keuze. Ook kunt u geen rechten ontlenen aan het invullen van een regelhulp.
  - Het ministerie van Binnenlandse Zaken en Koninkrijksrelaties is niet verantwoordelijk voor de inhoud van externe websites waarnaar deze regelhulp verwijst.
  - De antwoorden die u geeft en de uitkomst die u van de regelhulp krijgt, zijn bestemd voor uw eigen gebruik. Het ministerie van Binnenlandse Zaken en Koninkrijksrelaties registreert alleen hoe vaak de regelhulp wordt gebruikt.

      `
    }
  };

  var closeinfo = function () {
    try {
      window.location.assign("#");
    } catch (e) {
      window.console && window.console.log(e);
    }
  };

  $(doc).ready(function () {
    $(doc).on("bb:postHandleData", function (e, data) {
      if (data && data.modelname) {
        if (Object.keys(models).indexOf(data.modelname) > -1) {
          $(".p-disclaimer-link").removeAttr("hidden");
          if (models[data.modelname].mdable) {
            doc.querySelector(".p-disclaimer-text").innerHTML =
              converter.makeHtml(
                escapeHTML(models[data.modelname].text),
                false
              );
          } else {
            $(".p-disclaimer-text").text(models[data.modelname].text);
          }
        } else {
          $(".p-disclaimer-link").attr("hidden", true);
        }
      }
    });

    $(doc).on("click", "#disclaimer-info", function (e) {
      if ($(e.target).attr("id") === "disclaimer-info") {
        closeinfo();
      }
    });

    $(doc).on("keydown", function (e) {
      if ($("#disclaimer-info").is(":visible")) {
        switch (e.which) {
          case 13:
          case 27:
            closeinfo();
            break;
          default:
            break;
        }
      }
    });
  });
})(jQuery, window, document);
